import { createIconSet } from 'react-native-vector-icons';
import glyphMap from './glyphmaps/PhosphorIcons.json';
export const IconSetRegular = createIconSet(glyphMap, 'Phosphor', 'Phosphor.ttf');
export const IconSetFill = createIconSet(glyphMap, 'Phosphor-Fill', 'Phosphor-Fill.ttf');
export const IconSetBold = createIconSet(glyphMap, 'Phosphor-Bold', 'Phosphor-Bold.ttf');
//# sourceMappingURL=PhosphorIcons.js.map